import axios from "axios";
import { getSessionId } from "./session";
import { API } from "./uploads";

const TOKEN_KEY = "kyp_token";
const USER_KEY = "kyp_user";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export function getCachedUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function storeSession(token, user) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (e) {}
}

export function clearSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (e) {}
}

// Attach Authorization header to every /api request when a token is present.
axios.interceptors.request.use((config) => {
  const token = getToken();
  const url = config.url || "";
  if (token && url.includes("/api/")) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export async function register(email, password, name) {
  const res = await axios.post(`${API}/auth/register`, {
    email,
    password,
    name,
    session_id: getSessionId(),
  });
  storeSession(res.data.token, res.data.user);
  return res.data;
}

export async function login(email, password) {
  const res = await axios.post(`${API}/auth/login`, {
    email,
    password,
    session_id: getSessionId(),
  });
  storeSession(res.data.token, res.data.user);
  return res.data;
}

export async function googleSignIn(credential) {
  const res = await axios.post(`${API}/auth/google`, {
    credential,
    session_id: getSessionId(),
  });
  storeSession(res.data.token, res.data.user);
  return res.data;
}

export async function me() {
  const res = await axios.get(`${API}/auth/me`);
  return res.data;
}

export async function forgotPassword(email) {
  const res = await axios.post(`${API}/auth/forgot-password`, { email });
  return res.data;
}

export async function resetPassword(token, newPassword) {
  const res = await axios.post(`${API}/auth/reset-password`, {
    token,
    new_password: newPassword,
  });
  // Auto-login: backend returns a fresh JWT.
  storeSession(res.data.token, res.data.user);
  return res.data;
}

export async function linkSession() {
  const res = await axios.post(`${API}/auth/link-session`, {
    session_id: getSessionId(),
  });
  return res.data;
}

export async function listMyUploads() {
  const res = await axios.get(`${API}/me/uploads`);
  return res.data;
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}
